
import { createContext,useContext,useEffect,useState } from "react";


export type UserModelType = {

// data class UserModel(val id : String,
//                      val userName : String,
//                      val name : String,
//                      val lastName : String,
//                      val emailAddress : String,
//                      val startDate : Long,
//                      val endDate : Long,
//                      val jobId : Int,
//                      val reportTypeId : Int,)

    username: string,
    name: string,
    lastName: string,
    emailAddress: string,
    startDate: number,
    endDate: number,
    jobId: number,
    reportTypeId: number,
    companyName: string,
    completedTutorial : boolean,
    affiliateId : string,
    profilePhotoBase64 : string|null,

}

interface AuthContextType{
        accessToken: string|null,
        refreshToken: string|null,
        user : UserModelType|null,
        setAccessToken: (accessToken: string) => void,
        setRefreshToken: (refreshToken: string) => void,
        setUser: (user: UserModelType) => void,


}

const AuthContext = createContext({
    accessToken: null,
    refreshToken: null,
    user : null,
    setAccessToken: (accessToken: string) => {},
    setRefreshToken: (refreshToken: string) => {},
    setUser: (user: UserModelType) => {},

  
} as AuthContextType);




export function AuthProvider({ children } : { children: React.ReactNode }) {

        // const [username, setUsername] = useState("");
        // const [password, setPassword] = useState("");

        
      
        const [accessToken, setAccessToken] = useState<string|null>(localStorage.getItem("accessToken")??null);
        const [refreshToken, setRefreshToken] = useState<string|null>(localStorage.getItem("refreshToken")??null);
        const [user, setUser] = useState<UserModelType|null>(JSON.parse(localStorage.getItem("user")??null));
      
        
        useEffect(() => {

          
                localStorage.setItem("accessToken", accessToken);
            ////console.log("accessToken set to localStorage -> " + accessToken)
                localStorage.setItem("refreshToken", refreshToken);
            ////console.log("refreshToken set to localStorage -> " + refreshToken)
                localStorage.setItem("user", JSON.stringify(user));
            
            
        },[accessToken,refreshToken,user])


        const authContext ={
                accessToken,
                refreshToken,
                user,
                setAccessToken,
                setRefreshToken,
                setUser
        };

        
       


    return (
        <AuthContext.Provider value={authContext}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuthContext() {return useContext(AuthContext);};
